// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18824":"df7fc85a","39786":"092579e0","43774":"092579e0","57109":"7dcc6be9"}[chunkId] + ".chunk.css";
};